//CRN_20260826 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })

export class ModalForceCloseService {

  private forcing: boolean=false;

  constructor(
    private exceptionsService: ExceptionsService,
    private modalService     : NgbModal
  ) { }

  public dismissAllForced(reason?: any): void {
    try {
      this.forcing=true;

      this.modalService.dismissAll(reason);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
    finally {
      this.forcing=false;
    }
  }

  public isForcing(): boolean {
    try {
      return this.forcing;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
}
